import * as React from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Sort,
  Filter,
  Page
} from "@syncfusion/ej2-react-grids";

export default function PaginatedTableDashboard({ id, data, columns }) {
  return (
    <div className="m-4">
      <GridComponent
        id={id}
        dataSource={data}
        allowPaging={false}
        allowSorting={true}
        gridLines="None"
        width="100%"
      >
        <ColumnsDirective>
          {columns.map((col, index) => (
            <ColumnDirective key={index} {...col} />
          ))}
        </ColumnsDirective>
        <Inject services={[Sort, Filter, Page]} />
      </GridComponent>
    </div>
  );
}

